import {FC, MouseEvent} from 'react';

import {PromoPayload} from '~/services/hot-api/notifications';
// import RedLink from '~/common/RedLink';
import Icon from '~/common/Icon';
import Button from '~/common/Button';
import CustomLink from '~/common/CustomLink';

import {PromotionButtons} from './constants';
import s from './styles.module.scss';

interface ActionPromoProps {
  payload: PromoPayload;
  onAction?: (url: string) => void;
  variant?: 'normal' | 'light';
  onClose?: () => void;
}

const ActionPromo: FC<ActionPromoProps> = ({payload, onAction, variant, onClose}) => {
  const links = PromotionButtons.filter((item) => item.type !== payload.createdPromo);

  return (
    <div className={s['action-promo']}>
      <div className={s['action-promo__grid']}>
        {links.map((item) => {
          const handleButtonClick = async (event: MouseEvent) => {
            const currentUrl = `${window.location.pathname}${window.location.hash}`;

            if (onAction) {
              await onAction(item.url);
            }
            if (item.url === currentUrl) {
              event.preventDefault();
            }
          };

          return (
            <CustomLink
              key={item.type}
              className={s['action-promo__link']}
              onClick={handleButtonClick}
              to={item.url}
              external
            >
              <Icon name={item.icon} />
              <span>{item.label}</span>
            </CustomLink>
          );
        })}
      </div>
      {variant !== 'light' && (
        <Button className={s['action-promo__close-btn']} onClick={onClose}>
          Do it later
        </Button>
      )}
    </div>
  );
};

export default ActionPromo;
